let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gZU54")).then(() => parcelRequire('1OKs8'));